import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { EmergencyBanner } from './EmergencyBanner';
import { StarterDashPromptingBanner } from './StarterDashPromptingBanner';

export const BannerSection: React.FC = () => {
	const {
		data: { starterDashboardPromptingBannerEnabled },
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: { emergencyBannerContent: emergencyBanner },
		},
	} = usePetitionDetailsPageData();

	if (emergencyBanner) {
		return <EmergencyBanner emergencyBanner={emergencyBanner} />;
	}

	if (starterDashboardPromptingBannerEnabled) {
		return <StarterDashPromptingBanner />;
	}

	return null;
};
